// Unpublished Work © 2020-2022 Deere & Company

import t from 'tcomb';

export const addressType = {
    MAILING: 'M',
    PHYSICAL: 'P'
};

export const addressTypeLabels = {
    MAILING: 'Postal Address',
    PHYSICAL: 'Delivery Address'
};

export const AddressType = t.enums.of(Object.values(addressType), 'AddressType');

export const AddressTypeLabels = t.enums.of(Object.values(addressTypeLabels), 'AddressTypeLabels');
